// JavaScript для cover
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для cover
});
